import { render, staticRenderFns } from "./ServiceSelector.vue?vue&type=template&id=854e3d68&scoped=true"
import script from "./ServiceSelector.vue?vue&type=script&lang=ts"
export * from "./ServiceSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854e3d68",
  null
  
)

export default component.exports